import React, { useEffect } from "react";
import { useStateManagerContext } from "~/context/stateManager";
import useDebounce from "~/hooks/useDebounce";
import errorTracker from "~/utils/errorTracker";

interface SentryTagManagerProps {
  children: React.ReactNode;
}

/**
 * This component wrapper handles assigning tags to Sentry errors. Note that
 * tags are appended when a Sentry exception happens; calling `setTags` will not
 * in itself trigger a request to Sentry. Therefore it is safe to call setTags
 * frequently without debouncing.
 */
const SentryTagManager = ({ children }: SentryTagManagerProps) => {
  const { sdkState } = useStateManagerContext();

  useEffect(() => {
    errorTracker.setTags({
      api_key: sdkState.apiKey,
      host_url: document.referrer,
    });
  }, []);

  /**
   * On globalOption change
   */
  useEffect(() => {
    errorTracker.setTags({
      locale: sdkState.globalOptions?.locale,
    });
  }, [sdkState.globalOptions]);

  /**
   * On option change
   */
  useEffect(() => {
    errorTracker.setTags({
      latitude: `${sdkState.options?.lat}`,
      longitude: `${sdkState.options?.lng}`,
    });
  }, [sdkState.options]);

  return <>{children}</>;
};

export default SentryTagManager;
